import axios from 'axios';

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 15000,
  headers: { Accept: 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const baseURL = config.baseURL ?? '';
  const url = config.url ?? '';

  console.log('[Renderer API Request]', {
    configuredBaseURL: import.meta.env.VITE_API_BASE_URL,
    axiosBaseURL: baseURL,
    endpoint: url,
    params: config.params,
    finalURL: `${baseURL}${url}`,
    headers: config.headers,
    browserURL: window.location.href,
  });

  return config;
});
